var _path, _circle, _circle2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCogIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64241 2.01418C6.27942 1.02896 7.72074 1.02896 8.35775 2.01418L8.59967 2.38835C9.14376 3.22986 10.0593 3.75844 11.0601 3.80888L11.5051 3.83131C12.6768 3.89036 13.3975 5.13858 12.8628 6.18286L12.6597 6.57945C12.203 7.4714 12.203 8.52856 12.6597 9.42051L12.8628 9.8171C13.3975 10.8614 12.6768 12.1096 11.5051 12.1687L11.0601 12.1911C10.0593 12.2415 9.14376 12.7701 8.59967 13.6116L8.35775 13.9858C7.72074 14.971 6.27942 14.971 5.64241 13.9858L5.40049 13.6116C4.8564 12.7701 3.94088 12.2415 2.94006 12.1911L2.49507 12.1687C1.32333 12.1096 0.602672 10.8614 1.13739 9.8171L1.34047 9.42051C1.79719 8.52856 1.7972 7.47141 1.34047 6.57945L1.1374 6.18286L0.478666 6.52016L1.13739 6.18286C0.602673 5.13858 1.32333 3.89036 2.49506 3.83131L2.94006 3.80888C3.94088 3.75844 4.8564 3.22986 5.40049 2.38835L5.64241 2.01418Z",
    stroke: "#009DD7",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.00013,
    cy: 8.00001,
    r: 3.15565,
    fill: "#009DD7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.00019,
    cy: 7.99994,
    r: 1.57782,
    fill: "#F3F2F6"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCogIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cog-icon.4649779a.svg";
export { ForwardRef as ReactComponent };